// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabPrepaid_slide_ZsP5l","slide-reverse":"TabPrepaid_slide-reverse_1zUq6","filter":"TabPrepaid_filter_lRs2A","btnTop":"TabPrepaid_btnTop_2r6Wp"};